import { defineStore } from 'pinia';
import CustomersApi from '../api/CustomersApi';
import { getAllOtsFlowConfigs, getFlowConfigByFlowId } from '../api/insightsApi';
import { OtsFlowConfig } from '../types/otsConfig';
import { CustomerData } from '../types/session';

export const useSessionStore = defineStore('session', {
  state: (): CustomerData => ({
    customerId: undefined,
    memberId: undefined,
    firstName: undefined,
    lastName: undefined,
    utmParams: undefined,
    allowedOtsFlowConfigs: [],
    otsFlowConfig: undefined,
  }),
  actions: {
    async init(): Promise<void> {
      const member = await CustomersApi.getPartiallyAuthenticatedMember();
      this.customerId = member.customerId;
      this.memberId = member._id;
    },

    async fetchAllowedOtsConfigs(): Promise<void> {
      const configs = await getAllOtsFlowConfigs();
      this.allowedOtsFlowConfigs = configs.map(config => config.flowConfigId);
    },

    async fetchOtsFlowConfig(flowId: string): Promise<OtsFlowConfig> {
      const flowConfig = await getFlowConfigByFlowId(flowId);
      this.otsFlowConfig = flowConfig;
      return flowConfig;
    },
  },

});
